module.exports = __webpack_public_path__ + "img/Correll_hall.7343d972.jpg";